import { Injectable } from '@angular/core';
import { IntegrateState } from './integrate_state';
import { getAccountPlatform } from '../platform_type';

@Injectable()
export class IntegrateStateCreator {
  create(allData: any): IntegrateState {
    return {
      platform: getAccountPlatform(allData.account.platform),
      platformErrors: allData.account.platformErrors,
      shopifyDeeplink: allData.shopDeeplink,
      hasWidgetV3: allData.feature.WidgetV3.featureEnabled,
    };
  }
}
